<template>
  <div>
    <Head title="Contacts" />
    <div class="events">

      <textblock :textblocks="textblocks" :auth="auth" :textid="1"></textblock>


      <br><br>
      <!-- <ul class="linklist">
        <li>
          <a href="/downloads/Preisblatt_Juli20.pdf" target="_blank" class="download">Preisblatt.pdf<br>(215 KB)</a>
        </li>
      </ul> -->


    <div class="calendar-header">
     <h3>Kalender</h3>
      <ul class="legend desktop">
        <li><span class="bg1"></span> Auditorium</li>
        <li><span class="bg2"></span> 26. OG Attika Innen</li>
        <li><span class="bg3"></span>  Ganzes 26. OG</li>
      </ul>
    </div>






      <div class="calendar-wrapper">
        <div class="input">
          <form @submit.prevent="addEvent">
            <div class="formrow">
              <label>Ort</label>
              <select v-model="form.location">
                  <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.name }}</option>
              </select>
            </div>
            <div class="formrow">
              <label>Anlass</label>
              <input v-model="form.title" type="text" >
            </div>
            <div class="formrow">
              <label>Datum</label>
              <Datepicker v-model="form.date" locale="de" autoApply :enableTimePicker="false"  format="dd.MM.yyyy" />
            </div>
              <div class="formrow">
                  <label>Zeit <sup>*</sup></label>
                  <select v-model="form.time">
                    <option v-for="(time,index) in timerange" :key="index" :value="time.start +'-'+ time.end">{{ time.name }} {{ time.time }}</option>
                  </select>
              </div>

            <div class="formrow">
                <label>Anzahl Teilnehmer <sup>*</sup></label>
                <input v-model="form.participants" type="text" >
            </div>
            <div class="formrow">
                <label>Firma <sup>*</sup></label>
                <input v-model="form.company" type="text" >
            </div>

            <div class="formrow">
                <label>Vorname <sup>*</sup></label>
                <input v-model="form.first_name" type="text" >
            </div>
            <div class="formrow">
                <label>Nachname <sup>*</sup></label>
                <input v-model="form.last_name" type="text" >
            </div>
            <div class="formrow">
                <label>E-Mail <sup>*</sup></label>
                <input v-model="form.email" type="text" >
            </div>
            <div class="formrow">
                <label>Telefon <sup>*</sup></label>
                <input v-model="form.phone" type="text" >
            </div>
            <div class="formrow">
                <label>Ihre Nachricht</label>
                <textarea v-model="form.message" type="text" ></textarea>
            </div>
            <div class="formrow">
              <input class="btn" type="submit" value="Reservieren" />
            </div>
          </form>
        </div>
        <div class="calendar">

          <vue-cal
            ref="vuecal"
            locale="de"
            :disable-views="['years', 'year']"
            :time-from="7 * 60" :time-to="22 * 60"
            :events="events"
            :on-event-click="onEventClick">
          >
          </vue-cal>

          <ul class="legend mobile">
            <li><span class="bg2"></span> Auditorium</li>
            <li><span class="bg1"></span> Dachterasse</li>
            <li><span class="bg3"></span> Foyer</li>
          </ul>


          <div class="dialog" v-if="showDialog">
            <div :class="'dialog-card ' + selectedEvent.class">
              <div class="dialog-card-title">
                <span>{{ selectedEvent.title }}</span>
                <svg @click="showDialog=false" class="" xmlns="http://www.w3.org/2000/svg" width="235.908" height="235.908" viewBox="278.046 126.846 235.908 235.908"><path d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"></path></svg>
              </div>
              <div class="dialog-card-text">
                <table>
                  <tr>
                    <td>Ort:</td>
                    <td>{{ selectedEvent.location.name }}</td>
                  </tr>
                  <tr>
                    <td>Datum:</td>
                    <td>{{ selectedEvent.start && selectedEvent.start.format('DD.MM.YYYY') }}</td>
                  </tr>
                  <tr>
                    <td>Zeit:</td>
                    <td>{{ selectedEvent.start && selectedEvent.start.formatTime() }} - {{ selectedEvent.end && selectedEvent.end.formatTime() }}</td>
                  </tr>
                  <tr>
                    <td>Kontakt:</td>
                    <td>
                      <div v-if="selectedEvent.company">{{ selectedEvent.company }}</div>
                      <div>{{ selectedEvent.first_name }} {{ selectedEvent.first_name }}</div>
                      <div>Tel: {{ selectedEvent.phone }} </div>
                      <div>E-Mail: {{ selectedEvent.email }} </div>
                    </td>
                  </tr>
                </table>
                <p class="message" v-if="selectedEvent.message" v-html="selectedEvent.message"/>

                <button @click.prevent="deleteEvent(selectedEvent)">delete Event</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

import Textblock from '@/Shared/Textblock'

import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/de.js'
import 'vue-cal/dist/vuecal.css'
import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  components: {
    Head,
    Link,
    VueCal,
    Datepicker,
    Textblock
  },
  layout: Layout,
  props: {
    events: Object,
    locations: Object,
    textblocks: Object,
    auth: Object,
  },
  data() {
    return {
      selectedEvent: {},
      showDialog: false,

      form:{
        date: null,
        timestart: null,
        timeend: null,
        title: null,
        location: null,
        time: null,
        participants: null,
        company: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null,
      },
      timerange:{
        0: {name: 'Vormittag', time: '7.00 Uhr - 12.30 Uhr', start: '7:00', end: '12:30'},
        1: {name: 'Nachmittag', time: '12.30 Uhr - 17.00 Uhr', start: '12:30', end: '17:00'},
        2: {name: 'Abend', time: '17.00 Uhr - 24.00 Uhr', start: '17:00', end: '23:59'},
        3: {name: 'Ganzer Tag', time: '7.00 Uhr - 17.00 Uhr', start: '7:00', end: '17:00'},
        4: {name: 'Ganzer Tag', time: '7.00 Uhr - 24.00 Uhr', start: '7:00', end: '23:59'}
      }
    }
  },
  computed: {
    dateFormated() {
       return this.form.date ? this.formatDate(this.form.date) : null
    },
    datetimeFrom() {
      return this.form.date ? this.dateFormated + " " + this.form.timestart : null
    },
    datetimeTo() {
       return this.form.date ? this.dateFormated + " " + this.form.timeend : null
    }
  },
   mounted() {
     let app = this;
    this.$parent.bgimage = "/img/tower2.jpg";

     setTimeout(function() {
          const { texts } = app.$refs.vuecal;
          texts.weekDays = texts.weekDays.map(text => text.substring(0, 2));
          app.textblock = app.textblocks.find(x => x.id === 1);
      }, 5);
  },


  methods: {
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    },
    getTimes() {
      var times = [];
      for(let x = 7; x <= 22; x++)
      {
        times.push( (x < 10 ? "0":"") + x + ":00" );
        times.push( (x < 10 ? "0":"") + x + ":30" );
      }
      return times;
    },
    onEventClick (event, e) {
      this.selectedEvent = event
      this.showDialog = true
      // Prevent navigating to narrower view (default vue-cal behavior).
      e.stopPropagation()
    },
    addEvent(){
      let app = this;

      var T = false;
      if(app.form.time)
      {
        T = app.form.time.split("-");
      }


      if(T){
        app.form.timestart = T[0];
        app.form.timeend = T[1];
      }else{
          app.form.timestart = '';
          app.form.timeend = '';
      }

      let formdat = this.$inertia.form({
        datetime_from: this.datetimeFrom,
        datetime_to: this.datetimeTo,
        title: this.form.title,
        participants: this.form.participants,
        message: this.form.message,
        location_id: this.form.location,
        company: this.form.company,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        phone: this.form.phone,
        email: this.form.email,
      });

      formdat.put('/events',{
        onSuccess: page => {
            this.form.date = null,
            this.form.timestart = null,
            this.form.timeend = null,
            this.form.title = null,
            this.form.location = null,
            this.form.participants = null,
            this.form.message = null
        },
      })
    },

    deleteEvent: function(event) {
      let app = this;
      this.$inertia.visit('/events/'+event.id, {
        method: 'delete',

        preserveState: true,
        preserveScroll: true,

        onSuccess: page => {
          app.showDialog = false
        },
        onError: errors => {},
        onFinish: visit => {},
      })
    },

    closeDialog: function(){
      let app = this;
      setTimeout(function() {app.showDialog = false}, 20);
    }





  },
}
</script>
